import { useSharedValue } from 'react-native-reanimated';

export const BUTTON_WIDTH = 75;

export function GestureDetector({ children }: { children: React.ReactNode }) {
  return children;
}

export function GestureHandlerRootView({
  children
}: { children: React.ReactNode }) {
  return children;
}

export const useSwipeLeft = (_callback: () => void) => {
  const translateX = useSharedValue(0);
  const previousTranslateX = useSharedValue(0);

  return { translateX, previousTranslateX, pan: null };
};
